import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { NavigationBarIcon } from '@fuww/library/src/Navigation';
import Dropdown from '@fuww/library/src/DropdownMenu';
import UserIcon from '@fuww/library/src/Icons/User';
import LoadingIcon from '@fuww/library/src/Icons/Loading';
import { useRouter } from 'next/router';
import AccountBox from '@fuww/library/src/Icons/AccountBox';
import Logout from '@fuww/library/src/Icons/Logout';
import Login from '@fuww/library/src/Icons/Login';
import PersonAddAlt from '@fuww/library/src/Icons/PersonAddAlt';
import Cached from '@fuww/library/src/Icons/Cached';
import UserAvatar from '../Users/UserAvatar';
import LinkAndAnchor from '../LinkAndAnchor';
import { UserContext } from '../UserProvider';
import messages from '../../lib/messages';
import { saveRouterState } from '../../lib/routerState';
import clearSiteData from '../../lib/clearSiteData';

const UserTab = () => {
  const intl = useIntl();
  const router = useRouter();
  const { user, loading } = useContext(UserContext);

  if (loading) {
    return (
      <NavigationBarIcon>
        <LoadingIcon
          title={intl.formatMessage(messages.loading)}
        />
      </NavigationBarIcon>
    );
  }

  const userItems = [
    <LinkAndAnchor
      route="profile"
      aria-label="Profile"
      fullWidth
    >
      <AccountBox fontSize="medium" />
      <span>
        {intl.formatMessage(messages.profile)}
      </span>
    </LinkAndAnchor>,
    <LinkAndAnchor
      route="logout"
      aria-label="logout"
      fullWidth
    >
      <Logout fontSize="medium" />
      <span>
        {intl.formatMessage(messages.logout)}
      </span>
    </LinkAndAnchor>,
  ];

  const guestItems = [
    <LinkAndAnchor
      route="login"
      aria-label="Login"
      onClick={() => {
        saveRouterState(router);
      }}
      fullWidth
    >
      <Login fontSize="medium" />
      <span>
        {intl.formatMessage(messages.login)}
      </span>
    </LinkAndAnchor>,
    <LinkAndAnchor
      route="register"
      aria-label="Create Account"
      fullWidth
    >
      <PersonAddAlt fontSize="medium" />
      <span>
        {intl.formatMessage(messages['register.createAccount'])}
      </span>
    </LinkAndAnchor>,
  ];

  const menuItems = [...(user ? userItems : guestItems), (
    <LinkAndAnchor
      onClick={clearSiteData}
      useRouter={false}
      href="/"
    >
      <Cached fontSize="medium" />
      <span>{intl.formatMessage(messages.resetAndReload)}</span>
    </LinkAndAnchor>
  )];

  return (
    <Dropdown
      top={(
        <NavigationBarIcon>
          { user ? (
            <UserAvatar
              size={24}
              user={user}
            />
          ) : (<UserIcon title="User" />) }
        </NavigationBarIcon>
      )}
      menuItems={menuItems}
    />
  );
};

export default UserTab;
